
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busonrentinhinjewadi() {



    const cardData =
    {
        keyword: 'Bus on Rent in Hinjewadi',
        heading: 'Amruta Travels: Bus on Rent in Hinjewadi',
        headingDescription: 'Amruta Travels offers Bus on Rent in Hinjewadi, providing reliable and comfortable transportation solutions for various occasions. Whether you are organizing a corporate event, school trip, family function, or group tour, our well-maintained buses ensure a smooth and enjoyable journey. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your travel in and around Hinjewadi simple and stress-free. Book your bus with Amruta Travels and experience a journey of comfort and convenience!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



  "services": [
    {
      "name": "Bus on Rent Hire in Wakad",
      "description": "Amruta Travels offers reliable bus rental services in Wakad, Pune. Whether it's for corporate outings, group tours, or personal events, we provide a fleet of well-maintained buses with experienced drivers to ensure a safe and comfortable journey."
    },
    {
      "name": "Bus on Rent in Hinjewadi for Corporate Outing",
      "description": "Rent a bus in Hinjewadi for corporate outings with Amruta Travels. Our buses are perfect for team-building activities, corporate events, and office trips. Choose from various bus sizes with AC comfort and professional drivers to ensure a seamless experience."
    },
    {
      "name": "Bus on Rent in Hinjewadi for Outstations",
      "description": "Amruta Travels provides bus rentals in Hinjewadi for outstation trips. Whether it's a leisure trip, a business trip, or a pilgrimage tour, we offer comfortable and affordable buses for groups of all sizes, ensuring timely and safe travel."
    },
    {
      "name": "Bus Hire for Wedding Hinjewadi",
      "description": "Planning a wedding in Hinjewadi? Hire a bus with Amruta Travels for transporting guests to and from the wedding venue. We offer buses of various sizes with luxury features to ensure your guests' comfort on your special day."
    },
    {
      "name": "Bharat Benz 35 Seater Bus on Rent in Hinjewadi",
      "description": "Experience luxury travel with the Bharat Benz 35-seater bus rental in Hinjewadi. Perfect for large groups, corporate trips, or special events, this bus comes equipped with modern amenities to ensure a comfortable and premium experience."
    },
    {
      "name": "Force Urbania Luxury Mini Bus on Rent in Hinjewadi",
      "description": "Rent a Force Urbania luxury mini bus in Hinjewadi for your group travel needs. Ideal for corporate outings, family trips, or any special occasion, this bus offers luxurious seating, air conditioning, and modern facilities for a comfortable journey."
    },
    {
      "name": "Corporate Outing Bus Hire in Hinjewadi",
      "description": "Amruta Travels offers corporate outing bus hire services in Hinjewadi. Our buses are perfect for corporate team-building activities, conferences, and other professional events. Choose from various sizes with premium features to suit your needs."
    },
    {
      "name": "Tempo Traveller Hire in Hinjewadi",
      "description": "Hire a tempo traveller in Hinjewadi for group travel with Amruta Travels. Our tempo travellers are equipped with AC, push-back seats, and spacious interiors to ensure a comfortable and enjoyable journey for small to medium-sized groups."
    },
    {
      "name": "Mini Bus on Rent in Hinjewadi",
      "description": "Rent a mini bus in Hinjewadi with Amruta Travels for family outings, group tours, or corporate events. Our mini buses are comfortable, well-maintained, and offer flexibility in seating arrangements for smaller groups."
    },
    {
      "name": "Bus Hire for Marriage in Hinjewadi",
      "description": "Amruta Travels provides bus rental services for weddings in Hinjewadi. Our buses ensure that your wedding guests travel comfortably to and from the venue, with ample seating and reliable service for a smooth and timely journey."
    },
    {
      "name": "Bus Hire for Wedding Near Me Pune",
      "description": "Looking for bus hire services for a wedding near you in Pune? Amruta Travels offers a range of buses for wedding transportation. Ensure that your guests are comfortable and on time with our reliable and punctual services."
    },
    {
      "name": "14 17 25 32 Seater Bus on Rent in Hinjewadi",
      "description": "Amruta Travels offers a variety of buses for rent in Hinjewadi, including 14, 17, 25, and 32-seater options. Perfect for group tours, corporate events, or family gatherings, these buses come with AC and are ideal for small to medium-sized groups."
    }
  ],
  "tableData": [
    ["Bus on Rent Hire in Wakad", "Bus on Rent in Hinjewadi for Corporate Outing"],
    ["Bus on Rent in Hinjewadi for Outstations", "Bus Hire for Wedding Hinjewadi"],
    ["Bharat Benz 35 Seater Bus on Rent in Hinjewadi", "Force Urbania Luxury Mini Bus on Rent in Hinjewadi"],
    ["Corporate Outing Bus Hire in Hinjewadi", "Tempo Traveller Hire in Hinjewadi"],
    ["Mini Bus on Rent in Hinjewadi", "Bus Hire for Marriage in Hinjewadi"],
    ["Bus Hire for Wedding Near Me Pune", "14 17 25 32 Seater Bus on Rent in Hinjewadi"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Bus Rental Service in Hinjewadi, Pune",
    "WhyChoosedescription": "Amruta Travels offers dependable and professional Bus on Rent in Hinjewadi, Pune—catering to corporate outings, team building trips, weddings, educational tours, and family events. Whether you need a short ride or a full-day trip, we provide a well-maintained fleet and exceptional service for all types of group travel."
  },
  {
    "WhyChooseheading": "Variety of Buses for Every Group Size",
    "WhyChoosedescription": "We offer a diverse fleet of buses including 17, 20, 32, 35, 40, 45, and 50-seater options. Our buses are designed for comfort and convenience, featuring spacious seating, ample luggage space, and air conditioning (or non-AC on request), ensuring a pleasant journey for every group, no matter the size."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Wedding, and Social Events",
    "WhyChoosedescription": "Hinjewadi, being an IT hub and a popular location for events, makes our bus rental services perfect for corporate shuttles, employee transport, conferences, weddings, and family outings. We provide punctual, professional service to ensure smooth travel for your team or guests, making sure they arrive on time and in comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Expertise",
    "WhyChoosedescription": "Our drivers are well-trained and have extensive experience with Hinjewadi’s roads and the major highways around Pune. Whether you're heading to Lonavala, Mahabaleshwar, or a local event, our courteous drivers ensure safety, efficiency, and a hassle-free journey, offering an enjoyable travel experience every time."
  },
  {
    "WhyChooseheading": "Affordable Pricing with Transparent Quotes",
    "WhyChoosedescription": "Amruta Travels offers competitive and budget-friendly pricing for Bus on Rent in Hinjewadi. We provide clear, upfront quotes with no hidden charges, allowing you to plan your group travel expenses without any surprises. Whether you need transportation for a few hours or an entire day, we offer flexible pricing to suit your needs."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained Buses for Comfort and Safety",
    "WhyChoosedescription": "We take cleanliness and safety seriously. Our buses are regularly serviced, cleaned, and inspected to maintain high standards. Equipped with push-back seats, large windows, air conditioning, and clean interiors, our buses provide a comfortable and safe ride, whether you're traveling locally or to outstation destinations."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Points in Hinjewadi",
    "WhyChoosedescription": "We offer flexible pickup and drop-off options across Hinjewadi, including areas like Rajiv Gandhi Infotech Park, Phase 1, 2, and 3, as well as surrounding locations like Baner, Aundh, and Wakad. Our buses are punctual, ensuring you can stick to your planned schedule and travel with ease."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking a bus in Hinjewadi is simple with Amruta Travels. You can book online, via phone, or in-person at our office. Our customer support team is available 24/7 to assist you with reservations, provide detailed information, and offer assistance with any special requests, ensuring a smooth booking experience."
  }
]























    }

const faqData = [
  {
    question: 'How can I rent a bus in Hinjewadi, Pune?',
    answer: 'Renting a bus in Hinjewadi with Amruta Travels is easy. You can book by calling us, using our online booking system, or visiting our office. We’ll help you find the right bus based on your group size and travel requirements.',
  },
  {
    question: 'What types of buses are available for rent in Hinjewadi?',
    answer: 'We offer a variety of buses including 32, 35, 40, 45, and 50-seater options. Choose from AC, non-AC, and luxury buses, all equipped for comfort and long-distance travel.',
  },
  {
    question: 'Do you offer buses for local travel within Hinjewadi?',
    answer: 'Yes, we provide buses for local travel in Hinjewadi for corporate transport, events, conferences, city tours, and other short-distance trips.',
  },
  {
    question: 'Can I rent a bus for outstation travel from Hinjewadi?',
    answer: 'Yes, we offer outstation bus rentals from Hinjewadi to destinations like Mumbai, Goa, Shirdi, Mahabaleshwar, and more. Our experienced drivers ensure a safe and comfortable journey.',
  },
  {
    question: 'Are the buses well-maintained and comfortable?',
    answer: 'Yes, all our buses are regularly serviced, cleaned, and sanitized to ensure safety, comfort, and hygiene. We prioritize passenger satisfaction with comfortable seating and modern amenities.',
  },
  {
    question: 'How much does it cost to rent a bus in Hinjewadi?',
    answer: 'The cost varies depending on the bus type, travel distance, and trip duration. Contact us for a personalized and transparent quote based on your requirements.',
  },
  {
    question: 'Do you offer buses for corporate transport in Hinjewadi?',
    answer: 'Yes, we provide reliable and punctual buses for corporate events, team outings, and daily staff transport within Hinjewadi and surrounding IT hubs.',
  },
  {
    question: 'Can I request multiple pickup and drop points in and around Hinjewadi?',
    answer: 'Yes, we provide flexible routes with multiple pickup and drop-off points in Hinjewadi. Share your schedule and locations, and we’ll plan the most efficient route.',
  },
  {
    question: 'Why choose Amruta Travels for bus rental in Hinjewadi?',
    answer: 'Amruta Travels is known for its reliable service, clean and well-maintained buses, professional drivers, and customer-oriented approach. We aim to make your journey stress-free and comfortable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    role: 'HR Manager, Hinjewadi IT Park',
    text: 'We hired a 50-seater bus for a corporate event in Hinjewadi. The service was exceptional – the bus was on time, comfortable, and clean. The driver was courteous and professional. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shruti Deshmukh',
    role: 'Event Coordinator, Hinjewadi',
    text: 'Amruta Travels provided a 35-seater luxury bus for a wedding event in Hinjewadi. Everything went smoothly, and our guests were very comfortable. I will definitely choose them for future events.',
    rating: 5,
  },
];


























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent in Hinjewadi Pune",
  "image": "https://bushireinpune.com/assets/images/bus-on-rent-in-hinjewadi.jpg",
  "description": "Amruta Travels offers bus rental services in Hinjewadi for corporate events, school trips, weddings, and group tours. Choose from 17, 32, and 50 seater buses, including AC and Non-AC options. Book affordable and comfortable bus hire in Hinjewadi Phase 1, 2, and 3 with experienced drivers and 24/7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-on-rent-in-hinjewadi"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Bus on Rent in Hinjewadi Pune | Corporate, Wedding & Group Travel</title>
  <meta 
    name="description" 
    content="Rent buses in Hinjewadi Phase 1, 2, and 3 for weddings, school trips, and corporate travel. 17 to 50 seater AC/Non-AC buses available. Reliable & affordable bus hire with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/46.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busonrentinhinjewadi;